"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingCycleMonths = void 0;
const map = {
    A2: 24,
    A3: 36,
    AN: 12,
    FF: 0,
    M3: 3,
    M6: 6,
    MO: 1,
    OT: 0,
    PE: 0,
    PG: 0,
    PM: 0,
    PP: 0,
    SP: 0,
    WE: 0,
};
const getBillingCycleMonths = (p) => map[p.billingCycle];
exports.getBillingCycleMonths = getBillingCycleMonths;
//# sourceMappingURL=getBillingCycleMonths.js.map